export const resources = {
  UploadPeopleModelOption: '',
  ManagePeopleModels: '',
  PeopleModelsLoadingPlaceholder: '',
  PeopleModelsLoadingErrorMessage: ''
};
